import React from 'react';
import '../../App.css';
import Footer from "../Footer";
import PDFViewer from '../PDFViewer';
import CardItem from '../CardItem';
import { useEffect } from 'react';

function Kinder() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <> 
            <div className='kinder-bg'>
                <h1 className="page-title">Kinder (Age: 4-6 y/o)</h1>
                <div className="subprogramme-container">
                    <div className="kad__container">
                        <div className="cards__wrapper">
                            <ul className="cards__items">
                                <CardItem 
                                src="images/kinder.jpg"
                                text="Explore Scratch Junior and simple mechanics with Lego Technic to spark curiosity and early coding skills."
                                label='Kinder (4-6)'
                                path='/kinder'
                                />
                            </ul>
                        </div>
                    </div>
                    <div className="subprogramme-pdf">
                        <PDFViewer path="pdf/Roblock-World-Program-Outline-Kinder.pdf" />
                    </div>
                </div>
            </div>           
            <Footer />
        </>
    )
}

export default Kinder
